__turbopack_context__.v({
  "carousel": "brands-banner-carousel-module__IXN6XG__carousel",
  "controls": "brands-banner-carousel-module__IXN6XG__controls",
  "single": "brands-banner-carousel-module__IXN6XG__single",
  "slide": "brands-banner-carousel-module__IXN6XG__slide",
  "track": "brands-banner-carousel-module__IXN6XG__track",
  "viewport": "brands-banner-carousel-module__IXN6XG__viewport",
});
